import Vue from "vue";
import VueI18n from "vue-i18n";
import es from "./translations/es";
import en from "./translations/en";
import { subdomains } from "@/common/consts";
import { getCurrentSubdomain } from "@/common/functions";

Vue.use(VueI18n);

const subdomain = getCurrentSubdomain();
let defaultLang;
let fallbackLang;

switch (subdomain) {
    case subdomains.ES:
        defaultLang = "es";
        fallbackLang = "en";
        break;
    default:
        defaultLang = "en";
        fallbackLang = "es";
}

const messages = {
    en,
    es
};

export const defaultConfig = {
    locale: defaultLang,
    fallbackLocale: fallbackLang,
    messages,
    silentTranslationWarn: true
};

const i18n = new VueI18n(defaultConfig);

export default i18n;



// WEBPACK FOOTER //
// ./src/common/multilanguage/i18n.js